module.exports = __webpack_public_path__ + "a5c4df0c64d1b5889c4a2ceb5e4d8308.svg";